/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GlobalFilterListItem,
    GlobalFilterListItemFromJSON,
    GlobalFilterListItemFromJSONTyped,
    GlobalFilterListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface GlobalFilterListItemPaginationWrapper
 */
export interface GlobalFilterListItemPaginationWrapper {
    /**
     * 
     * @type {Array<GlobalFilterListItem>}
     * @memberof GlobalFilterListItemPaginationWrapper
     */
    items?: Array<GlobalFilterListItem> | null;
    /**
     * 
     * @type {number}
     * @memberof GlobalFilterListItemPaginationWrapper
     */
    totalItems?: number;
}

export function GlobalFilterListItemPaginationWrapperFromJSON(json: any): GlobalFilterListItemPaginationWrapper {
    return GlobalFilterListItemPaginationWrapperFromJSONTyped(json, false);
}

export function GlobalFilterListItemPaginationWrapperFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalFilterListItemPaginationWrapper {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(GlobalFilterListItemFromJSON)),
        'totalItems': !exists(json, 'totalItems') ? undefined : json['totalItems'],
    };
}

export function GlobalFilterListItemPaginationWrapperToJSON(value?: GlobalFilterListItemPaginationWrapper | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(GlobalFilterListItemToJSON)),
        'totalItems': value.totalItems,
    };
}


